import React, { useMemo } from 'react';
import Controller from '../../mixins/Controller';
import Dialog from '../../components/Dialog';
import Utils from '../utility/Utils';
import Button from '../../components/Button';
import Form from '../../components/Form';
import Binder from '../../lib/Binder';
import InspectionGaugesRow from '../pages/InspectionGaugesRow';
import Searchers from '../utility/Searchers';
import AppConstants from '../utility/AppConstants';
import Table from '../../components/Table';
import Grid from '../../components/Grid';
import ActionIcon from '../../components/ActionIcon';
import LoginService from '../services/LoginService';
import DateTimeFormatter from '../../lib/DateTimeFormatter';
import GroupBadge from '../../components/GroupBadge';
import CropImageDialog from '../dialogs/CropImageDialog';
import DropZone from '../../components/DropZone';

class InspectionAssetImagesDialog extends React.Component {

    constructor(props, context) {
        super(props, context);

        Object.assign(this, Controller);
    }


    componentDidMount = () => {
        this.initializeMixin();
        // this.props.controller.constructJSONObject();
        this.props.controller.load();
    }


    handleClose = (result) => result.Cancel || result.OK ? true : this.props.controller.save();

    render = () => {
        var controller = this.props.controller;
        const binder = new Binder(this);
        const saveCancelButtons = <Dialog.OKButtons />;
        // : <Dialog.SaveCancelButtons saving={controller.state.disableSave} />;
        const buttons = controller.state.primrySerNumber?.id >= 0 ? saveCancelButtons : <Dialog.Buttons><Dialog.CloseButton /></Dialog.Buttons>;

        return (
            <Dialog {...this.props} className='pass-dialog' header={this.props.header} modal={true} width={730} height={630} id='gauges-test-dlg' onClose={this.handleClose}>
                <Dialog.Body>
                    
                        <InspectionGaugesTable controller={controller} binder={binder} />
                   
                </Dialog.Body>
                {buttons}
            </Dialog>
        );
    }
}

const InspectionGaugesTable = (props) => {

    var controller = props.controller;
    const rows = Utils.filterDeletedRecords(controller.state.rows) || [];
    var altResult = [...rows];
    const binder = props.binder;
    var testName = controller.state.testName;
    var jobNumber = controller.state.jobNumber;
    var jobNumberField = <span className='inspection-image-header'>Job Number : {jobNumber}</span>;
    var testNameField = <span className='inspection-image-header'>Test Name : {testName}</span>;
    var primarySerialNumberField = <span className='inspection-image-header'>Primary serial Number : {controller.state.primarySerialNumber}</span>
    
    const handleUploadDiagram = (res) => {
        const newFile = {
            id: Utils.newGuid(),
            fileName: res.file.name,
            size: res.file.size,
            altText: '',
            caption: '',
            file: res.file,
            fileType: res.file.name.split('.')[1] || '',
            url: res.imageUrl
        };
        if (!props.controller.validateUploadedFile(newFile.fileType)) {
            return false;
        }
        if(props.controller.uploadSignature(res, newFile))
        {
            Dialog.showDialog(<CropImageDialog controller={props.controller} header={props.controller.state.signatureImage.fileName} />);
        }
        
    }
   const uploadButton = <div className='d-flex' style={{ maxWidth: 446,maxHeight:50,alignItems: 'center',justifyContent:'right' }}>
         <DropZone onDrop={handleUploadDiagram} multiple={false} width={170} height={60} style={{ borderStyle: 'none', padding: 'unset' }}>
                  <Button type='file' variant='success' pill={false} icon='fa-upload' disabled={false} style={{ minWidth: 136, minHeight:30}}>Upload</Button>
  </DropZone>
   </div >

    var header = <div className='col-md-12' style={{ borderBottom: 'solid 2px #d8d8d8', paddingBottom: '5px', paddingleft: '0px', width: '98%' }}>
        <div className='row'>
            <div className='col-md-5'>
                {jobNumberField}
            </div>
            <div className='col-md-7'>
                {primarySerialNumberField}
            </div>
        </div>
        <div className='row'>
            <div className='col-md-5'>
                {testNameField}
            </div>
        </div>
        <div className='row'>
        <div className='col-md-12'>
            {uploadButton}
            </div>
        </div>
    </div>

    return (
        <div>
            {header}
        </div>
    );

}

export default InspectionAssetImagesDialog;